<template>
  <div class="uk-grid uk-child-width-1-1" data-uk-grid>
    <div>
      <div class="uk-align-right">
        <a @click.prevent="$router.go(-1)" class="uk-button uk-button-small uk-button-secondary">
          <span class="uk-margin-small-right uk-icon" uk-icon="icon: arrow-left"></span>
          Zurück
        </a>
      </div>
    </div>
    <div v-if="sales.length && !loading">
      <sale-list :sales="sales"></sale-list>
    </div>
  </div>
</template>
<script>
import SaleService from '@/services/sale.service'
import SaleList from '@/components/SaleList'
export default {
  data() {
    return {
      sales: [],
      loading: true
    }
  },
  components: {
    SaleList
  },
  mounted() {
    this.getSales()
  },
  methods: {
    async getSales() {
      const sales = await SaleService.get()
      this.sales = sales.data
      this.loading = false
    }
  }
}
</script>
